import { Observable } from "rxjs";

import { OrdersRepository } from "lib/repositories/index";
import st from "lib/utils/index";
import { OrderTransferDecorator } from "lib/decorators/index";

export const OPEN = "orders/AddOrderTransferModal/OPEN";
export const CLOSE = "orders/AddOrderTransferModal/CLOSE";
export const UPDATE_TRANSFER = "orders/AddOrderTransferModal/UPDATE_TRANSFER";
export const VALIDATE = "orders/AddOrderTransferModal/VALIDATE";
export const SUBMIT = "orders/AddOrderTransferModal/SUBMIT";
export const FETCH_SUBMIT_START = "orders/AddOrderTransferModal/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "orders/AddOrderTransferModal/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "orders/AddOrderTransferModal/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.orders.AddOrderTransferModal;

const initialState = {
  opened: false,
  initialOrder: null,
  transfer: null,
  errors: new st.form.ValidationErrors(),
  valid: true,
  submitLoading: false,
  saved: false,
};

const reducers = {
  [OPEN]: (state, { initialOrder, transfer }) => {
    return {
      ...initialState,
      opened: true,
      initialOrder,
      transfer,
    };
  },

  [CLOSE]: (state) => {
    return {
      ...state,
      opened: false,
    };
  },

  [UPDATE_TRANSFER]: (state, { transfer }) => {
    return {
      ...state,
      transfer,
    };
  },

  [VALIDATE]: (state, { submitValidate }) => {
    const { transfer } = state;
    const errors = new st.form.ValidationErrors();

    submitValidate && errors.add(`transfer.amount`, st.validators.presence(transfer.amount && transfer.amount.value));
    submitValidate &&
      errors.add(
        `transfer.amount`,
        st.validators.range(transfer.amount && transfer.amount.value, {
          greater_than: 0,
        })
      );

    if (errors.length > 0) {
      errors.add("base", I18n.t("papp.common.form_validation_error_message"));
    }

    return {
      ...state,
      valid: errors.valid,
      errors,
    };
  },

  [FETCH_SUBMIT_START]: (state) => {
    return {
      ...state,
      submitLoading: true,
      errors: new st.form.ValidationErrors(),
    };
  },

  [FETCH_SUBMIT_SUCCESS]: (state, { order }) => {
    return {
      ...state,
      initialOrder: order,
      saved: true,
      submitLoading: false,
    };
  },

  [FETCH_SUBMIT_FAILURE]: (state, { errors }) => {
    return {
      ...state,
      submitLoading: false,
      errors,
    };
  },
};

const epics = [
  (actions$, { getState, dispatch }) =>
    actions$
      .ofType(SUBMIT)
      .switchMap(() => {
        setTimeout(() => {
          dispatch(validate({ submitValidate: true }));
        });
        return actions$.ofType(VALIDATE).take(1);
      })
      .filter(() => {
        const { valid } = stateSelector(getState());
        return valid;
      })
      .flatMap(() => {
        const { transfer } = stateSelector(getState());
        return Observable.concat(
          Observable.of({ type: FETCH_SUBMIT_START }),
          OrdersRepository.createOrderTransfer(transfer.order_id, transfer)
            .map((order) => {
              return { type: FETCH_SUBMIT_SUCCESS, order };
            })
            .catch((error) => {
              st.api.handleError(error, { getState, dispatch });
              const errors = new st.form.ValidationErrors([["base", st.api.findResponseErrorMessage(error)]]);
              return Observable.of({
                type: FETCH_SUBMIT_FAILURE,
                errors,
                error,
              });
            })
        );
      }),
];

export function open({ order, transfer = {} }) {
  transfer = new OrderTransferDecorator({
    uuid: st.generateUuid(),
    order_id: order.id,
    order_token: order.token,
    sender: "customer",
    receiver: "supplier",
    transfer_type: "cash",
    amount: {
      value: 0,
      currency: order.product_price_currency,
    },
    transferred_at: moment().format(moment.RUBY_DATETIME_FORMAT),
    ...transfer,
  });
  return { type: OPEN, initialOrder: order, transfer };
}

export function close() {
  return { type: CLOSE };
}

export function updateTransfer(transfer) {
  return { type: UPDATE_TRANSFER, transfer };
}

export function validate({ submitValidate = false } = {}) {
  return { type: VALIDATE, submitValidate };
}

export function submit() {
  return { type: SUBMIT };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/orders/AddOrderTransferModal/index.js